export const getErrorMessage = (errorPayload: any, translations: any): string => {
  const errorKeys = translations.error;
  if (errorPayload?.code === 'Error.CannotDeactivateNotZeroSettlementsExists') {
    return errorKeys[errorPayload?.code] + ': ' + errorPayload?.context;
  }
  return errorKeys[errorPayload?.code];
};
